<template>
  <div>
    <loading-spinner
      v-if="loading"
      blur
      :showLabel="true"
      label="Loading magic..."
    />
    <b-container v-show="!loading">
      <b-row class="stats-row">
        <b-col md="12">
          <h4 class="mb-4">Server Storage Overview</h4>
        </b-col>
        <b-col md="4" class="mb-4">
          <b-card no-body class="stat-card total-card h-100">
            <b-card-body class="d-flex align-items-center">
              <div class="stat-icon mr-3">
                <b-icon-hdd-stack font-scale="2"></b-icon-hdd-stack>
              </div>
              <div class="stat-card-text">
                <h5 class="stat-label">TOTAL STORAGE</h5>
                <h2 class="stat-value">{{ storageData.totalGB }} GB</h2>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col md="4" class="mb-4">
          <b-card no-body class="stat-card free-card h-100">
            <b-card-body class="d-flex align-items-center">
              <div class="stat-icon mr-3">
                <b-icon-check-circle font-scale="2"></b-icon-check-circle>
              </div>
              <div class="stat-card-text">
                <h5 class="stat-label">FREE SPACE</h5>
                <h2 class="stat-value">{{ storageData.freeGB }} GB</h2>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col md="4" class="mb-4">
          <b-card no-body class="stat-card used-card h-100">
            <b-card-body class="d-flex align-items-center">
              <div class="stat-icon mr-3">
                <b-icon-exclamation-triangle
                  font-scale="2"
                ></b-icon-exclamation-triangle>
              </div>
              <div class="stat-card-text">
                <h5 class="stat-label">USED SPACE</h5>
                <h2 class="stat-value">
                  {{ storageData.usedGB }} GB
                  <span class="percentage"
                    >({{ storageData.usedPercentage }}%)</span
                  >
                </h2>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="12">
          <div class="progress-content">
            <b-progress height="10px" class="mb-2">
              <b-progress-bar
                :value="storageData.usedPercentage"
                variant="primary"
                striped
                animated
              ></b-progress-bar>
            </b-progress>
            <small class="text-muted"
              >Used: {{ storageData.usedPercentage }} %</small
            >
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import StorageChart from "@/components/StorageChart.vue";

import {
  BIconHddStack,
  BIconCheckCircle,
  BIconExclamationTriangle,
  BIconCalendar,
} from "bootstrap-vue";
import LoadingSpinner from "../Globals/LoadingSpinner.vue";
import axios from "axios";
export default {
  components: {
    StorageChart,
    BIconHddStack,
    BIconCheckCircle,
    BIconExclamationTriangle,
    BIconCalendar,
    LoadingSpinner,
  },
  data() {
    return {
      loading: true,
      storageData: {
        totalGB: 0,
        freeGB: 0,
        usedGB: 0,
        usedPercentage: 0,
      },
      chartData: null,
    };
  },

  methods: {
    async fetchStorageData() {
      try {
        this.loading = true;
        const response = await axios.post("/server-info");
        this.storageData = response.data;
        this.loading = false;
      } catch (error) {
        console.error("Error fetching storage data:", error);
      }
    },
  },
  mounted() {
    this.fetchStorageData();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style scoped>
.stats-row {
  margin-bottom: 2rem;
}

.stat-card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card-text {
  padding-left: 15px;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.total-card {
  background-color: #f8f9fe;
  border-left: 4px solid #4e73df !important;
}

.free-card {
  background-color: #f0f9f5;
  border-left: 4px solid #1cc88a !important;
}

.used-card {
  background-color: #fef8e6;
  border-left: 4px solid #f6c23e !important;
}

.stat-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
}

.total-card .stat-icon {
  background-color: #4e73df;
}

.free-card .stat-icon {
  background-color: #1cc88a;
}

.used-card .stat-icon {
  background-color: #f6c23e;
}

.stat-label {
  color: #6c757d;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}

.stat-value {
  color: #2c3e50;
  font-weight: 700;
  margin-bottom: 0;
}

.percentage {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 400;
}

.current-date {
  padding: 0.35rem 0.75rem;
  font-weight: 500;
}
</style>
